import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { injectThemeColors } from './utils/theme';
import { initializeAdminTheme } from './services/adminTheme';

// Inject theme colors before rendering the app
injectThemeColors();
initializeAdminTheme(window.location.pathname);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/pos-sw.js').catch((error) => {
      console.warn('POS service worker registration failed', error);
    });
  });
}
